import { DiagnosisEventQuery } from "./diagnosis-event-query";

export class AsmFileUpdateRequest {
    NewStatusID: number;
    Notes: string;
    Datetime: string;
    Query?: DiagnosisEventQuery;
    Source: string;
    TemplateName: string;
}
